(function ($) {



    $(document).on('ready', function () {

       $('textarea').each(function() {
           const maxLenAttr = $(this).attr('maxlength');

           if (!maxLenAttr) {
               $(this).attr('maxlength', 1000);
           }
       })

    });


})(jQuery);